import { createContext } from 'react';
import type { AuthContextValue } from './types';

/** Undefined outside a provider, so `useAuth` can fail loudly. */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
